import { CommonPage } from "../components/CommonPage";

type ProjectItemProps = {
  title: React.ReactNode;
  tag?: React.ReactNode;
  children?: React.ReactNode;
};
const ProjectItem = (props: ProjectItemProps) => {
  return (
    <div className="mb-4 rounded-md border border-slate-300 bg-slate-50 shadow-md dark:border-slate-700 dark:bg-slate-950">
      <div className="flex justify-between gap-2 px-3 py-2">
        <span className="font-bold">{props.title}</span>
        <span className="text-right text-slate-500">{props.tag}</span>
      </div>
      {props.children && <div className="px-3 py-2">{props.children}</div>}
    </div>
  );
};

export default function ProjectsPage() {
  return (
    <CommonPage>
      <title>Projects</title>
      <h2 className="text-center text-lg font-bold">Projects</h2>
      <div className="mt-8">
        <ProjectItem
          title="django-material-demo"
          tag="Individual Internship Project"
        >
          <p>
            Explores low-code CMS development solution and demonstrates Django
            admin site common use cases: CURD operations, form input, relational
            data editing, fetch and view static asset from cloud storage
          </p>
          <p>
            <strong>Technologies</strong>: Django, django-material, PostgreSQL,
            Amazon S3 bucket, Docker
          </p>
        </ProjectItem>
        <ProjectItem
          title="Authgear login system integration"
          tag="Internship Project"
        >
          <p>
            Integrate Authgear login system into a mobile application for a
            local shopping mall
          </p>
          <p>
            <strong>Responsibilities</strong>: UI/UX, backend logic for
            generating OTP code on behalf of end-user, fetch and render
            localization data from Google Sheets using Apps Script
          </p>
          <p>
            <strong>Technologies</strong>: React Native, Tailwind CSS, Golang,
            Docker, GraphQL, PostgreSQL, Elasticsearch, Google Apps Script
          </p>
        </ProjectItem>
        <ProjectItem
          title="HoloCoach &mdash; Virtual Reality Gamified Training"
          tag="Capstone Project"
        >
          <p>
            Explores the integration of Artificial Intelligence and Mixed
            Reality technologies to develop a gamified, collaborative learning
            platform that enhances online learning engagement and accessibility
          </p>
          <p>
            <strong>Responsibilities</strong>: System design, UI/UX, Testing,
            web service API, NFT and Virtual Wallet
          </p>
          <p>
            <strong>Technologies</strong>: Unity, C#, Python, JavaScript,
            Blender
          </p>
        </ProjectItem>
        <ProjectItem title="doodle-kitsune-randomizer">
          <p>
            Userscript for modifying the Doodle Champion Island Games (a Google
            Doodle game for the 2020 Summer Olympics) into an entrance
            randomizer, altering the playing style of the game
          </p>
          <p>
            <strong>Technologies</strong>: JavaScript, reverse engineering
          </p>
        </ProjectItem>
      </div>
    </CommonPage>
  );
}
